import { render, staticRenderFns } from "./TwoColSection.vue?vue&type=template&id=5de458e2&scoped=true&"
import script from "./TwoColSection.vue?vue&type=script&lang=js&"
export * from "./TwoColSection.vue?vue&type=script&lang=js&"
import style0 from "./TwoColSection.vue?vue&type=style&index=0&id=5de458e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de458e2",
  null
  
)

export default component.exports